import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { useParams } from 'react-router-dom';
import { CompanyPromotionForm } from '../../components/CompanyPromotionForm';
import { usePromotionForm } from '../../hooks/usePromotionForm';
import { useFormValidation } from '../../hooks/useFormValidation';
import { CircularProgressCenter } from '../../../../components/CircularProgressCenter';

export const EditCompanyPromotion = () => {
  const { id } = useParams();
  
  // Используем общий хук для управления формой
  const {
    formData,
    setFormData,
    loading,
    promotionLoading,
    error,
    cities,
    initiators,
    buttons,
    handleSubmit,
    handleCancel,
    handleButtonsUpdate,
    isInitialized
  } = usePromotionForm('edit', id);

  // Хук для валидации
  const { validateFullForm } = useFormValidation('edit');

  // Обработчик отправки формы
  const onSubmit = (data) => {
    return handleSubmit(data, validateFullForm);
  };

  if (promotionLoading || !isInitialized) {
    return <CircularProgressCenter />;
  }

  return (
    <Box>
      <Breadcrumbs sx={{ mb: '24px' }}>
        <Link href="/company-promotions" underline="hover">
          Акции компании
        </Link>
        <Typography color="text.primary">
          Редактировать акцию
        </Typography>
      </Breadcrumbs>

      <Typography mb="24px" variant="h1" sx={{ color: 'black' }} component="h1">
        Редактировать акцию
      </Typography>

      <CompanyPromotionForm
        formData={formData}
        setFormData={setFormData}
        onSubmit={onSubmit}
        onCancel={handleCancel}
        loading={loading}
        error={error}
        cities={cities}
        initiators={initiators}
        buttons={buttons}
        onButtonsUpdate={handleButtonsUpdate}
        isEdit={true}
      />
    </Box>
  );
};